import { DoubleSide } from 'three';

export const XRayMaterial = () => {
  return (
    <meshPhongMaterial
      color={0x4588e6}
      transparent={true}
      specular={0x333333}
      side={DoubleSide}
      opacity={0.5}
      depthWrite={false}
      toneMapped={true}
    />
  );
};
